import { ErrorPageComponent } from './error-page/error-page.component';
import { environment } from './../environments/environment.prod';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { AngularFireModule } from '@angular/fire';
// import { AngularFirestoreModule } from '@angular/fire/firestore';
// import { AngularFireAuthModule } from '@angular/fire/auth';
// import { AngularFireStorageModule } from '@angular/fire/storage';
// import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { LayoutComponent } from './layout/layout.component';
import { AppTopBarComponent } from './layout/app.topbar.component';

import { AppActionBarComponent } from './layout/app.actionbar.component';
import { AppFooterComponent } from './layout/app.footer.component';
import { AuthLayoutComponent } from './auth/layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TooltipModule } from 'primeng/tooltip';
import { HttpClientModule } from '@angular/common/http';
import { NotMigratedComponent } from './auth/not-migrated/not-migrated.component';
import { AppMenuitemComponent } from './layout/app.menuitem.component';
import { AppMenuComponent } from './layout/app.menu.component';

import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getFunctions, provideFunctions, connectFunctionsEmulator } from '@angular/fire/functions';



@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    AppTopBarComponent,
    AppMenuComponent,
    AppActionBarComponent,
    AppFooterComponent,
    AuthLayoutComponent,
    ErrorPageComponent,
    NotMigratedComponent,
    AppMenuitemComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    // AngularFireModule.initializeApp(environment.firebase),
    // AngularFireStorageModule,
    // AngularFireFunctionsModule,
    // AngularFirestoreModule,
    // AngularFireAuthModule,
    // AngularFireStorageModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideFunctions(() => {
      const fn = getFunctions()
      if (!environment.production) {
        // console.log('emulation mode');
        connectFunctionsEmulator(fn, "127.0.0.1", 5001);
      }
      return fn;
    }),
    provideStorage(() => getStorage()),
    ToastModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    BreadcrumbModule,
    TooltipModule,
    DropdownModule,
    OverlayPanelModule
  ],
  providers: [
    MessageService,
    ConfirmationService,
    DialogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
